import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/remainingSessionsSagas";
import ReactDatePicker from "../../../components/reactDatePicker/reactDatePicker";

const DatePicker = () => {
  const dispatch = useDispatch();
  const {
    currentUser: { calendarEndDate, calendarStartDate },
    selectedRequestDates: { startDate, endDate }
  } = useSelector((state) => state.sessions);

  const handleUpdateDates = (startDate, endDate) => {
    dispatch(actionCreators.updateDates({ startDate, endDate }));
  };

  return (
    <ReactDatePicker
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      isRangePicker
      minDate={calendarStartDate}
      updateDates={handleUpdateDates}
    />
  );
};

export default DatePicker;
